import { Component, computed, ViewChild, ElementRef, Output, EventEmitter, NgZone, effect, Input, signal, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { GenericValidationService } from '@app/common-codes/services/GenericValidationService';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { ActivatedRoute, Router } from '@angular/router';
import { OnReadyDirective } from '@app/common-codes/components/directives/OnReadyDirective';
import { FieldContextDirective } from '@app/common-codes/components/directives/FieldContext.directive';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { Trucker } from '@app/common-codes/models/matwins-tenant/Trucker.model';
import { ReactiveBadgeComponent } from '@app/common-codes/components/nested-components/reactive-badge/reactive-badge.component';
import { LookupItem, LookupProfile } from '@app/common-codes/services/LookupService';
import { MultiSelectComponent } from '@app/common-codes/components/nested-components/multi-select/multi-select.component';
import { FieldWrapperComponent } from '@app/common-codes/components/nested-components/field-wrapper/field-wrapper.component';

@Register(Trucker)
@Component({
  selector: 'app-trucker-detail',
  templateUrl: './trucker-detail.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, TranslatePipe, OnReadyDirective, ReactiveBadgeComponent, MultiSelectComponent, FieldWrapperComponent, FieldContextDirective]
})
export class TruckerDetailComponent extends GenetricDetailComponent<Trucker> {

  override ComponentEntityClass = Trucker;
  @Input() fkPointOfServiceId: number | null = null;
  Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  @Output() itemSaved = new EventEmitter<Trucker>();

  truckerStatusLookup = signal<LookupItem[]>([]);
  truckerValidationStateLookup = signal<LookupItem[]>([]);
  pointOfServiceLookup = signal<LookupItem[]>([]);
  languageLookup = signal<LookupItem[]>([]);

  onStatusChange(newStatus: number): void {
    const currentEntity = this.editingEntity();
    if (currentEntity) {
      const newEntity = Object.assign(new Trucker(), currentEntity);
      newEntity.status = newStatus;
      this.editingEntity.set(newEntity);
    }
  }

  onValidatedChange(newValue: number): void {
    const currentEntity = this.editingEntity();
    if (currentEntity) {
      const newEntity = Object.assign(new Trucker(), currentEntity);
      newEntity.validated = newValue;
      this.editingEntity.set(newEntity);
    }
  }

  constructor(
    route: ActivatedRoute,
    router: Router,
    translationService: TranslationService,
    validationService: GenericValidationService,
    alertModalService: AlertModalService,
    ngZone: NgZone
  ) {
    super(route, router, translationService, validationService, ngZone);
    this.alertModalService = alertModalService;
    effect(() => {

      const entity = this.editingEntity();
      if (entity) {
        // Lire la revision : si les lookups arrivent apres l'ouverture du formulaire, l'effet rejoue et regarnit les listes.
        this.lookupService.revision();
        this.truckerStatusLookup.set(this.getLookupData('TruckerStatus'));
        this.truckerValidationStateLookup.set(this.getLookupData('TruckerValidationState'));
        this.pointOfServiceLookup.set(this.lookupService.getLookupData('PointOfService'));
        this.languageLookup.set(this.getLookupData('i18nLanguage'));
        this.loadPos();
      }
    });
  }

  loadPos() {
    const entity = this.editingEntity();
    if (!entity) {
      return;
    }
    const selected = entity.fK_POS;
    if (!selected) {
      return;
    }
    entity.selectedPK_Pos = [selected.toString()];
  }

  onPOSselectChange(evt: string[]) {
    const truckerActivity = this.editingEntity();
    if (!truckerActivity) {
      return;
    }

    const selectedPosIds = (evt ?? [])
      .map(k => Number(k))
      .filter(n => Number.isFinite(n));

    // const newEntity = Object.assign(new TruckerActivity(), currentEntity);

    truckerActivity.fK_POS = selectedPosIds[0];
    truckerActivity.selectedPK_Pos = evt;
  }

  override getEmptyEntity(): Trucker {
    const trucker = new Trucker();
    trucker.status = 1;
    trucker.validated = 1;
    if (this.fkPointOfServiceId) {
      trucker.fK_POS = this.fkPointOfServiceId;
    }
    else if (this.matwinsVariablesService.posId) {
      trucker.fK_POS = this.matwinsVariablesService.posId;
    }
    return trucker;
  }

  override parseToEntityInstance(): void {
    if (this.EntityInstance && this.editingEntity()) {
      Object.assign(this.EntityInstance, this.editingEntity());
    }
  }

  async saveItem(): Promise<void> {
    const savedItem = await this.save();
    if (savedItem) {
      this.itemSaved.emit(savedItem);
    }
  }

  async saveAndCloseItem(): Promise<void> {
    const savedItem = await this.save();
    if (savedItem) {
      this.itemSaved.emit(savedItem);
      this.closeModal.emit();
    }
  }

  sendAgreements() {
    console.log('sendAgreements');
  }

}
